<template lang="pug">
  el-button.filter-by-type-button(id="FilterByTypeButton" type="text", size="mini")
    el-dropdown(trigger="click", @command="setMediaTypeFilterActive", :title="$t('Filter by media type')")
      el-button(
        size="mini",
        type="text",
        :class='{ active: activeType.length}'
      )
        font-awesome-icon(icon="filter", class="left-menu-dropdown-icon", :class='{ muted: !activeType.length}')
        span.type-name(v-if='activeType.length') {{ $t(options.find(opt => opt.command === activeType).displayName) }}
      el-dropdown-menu(slot='dropdown')
        el-dropdown-item(
          v-for='option of options',
          :command='option.command',
          :key='option.command',
          :divided='option.divided',
          :class='{ active: activeType === option.command}',
          :id="'FilterByTypeButton-dropdownOption' + option.command"
        )
          font-awesome-icon(:icon="option.icon")
          span &nbsp; &nbsp; {{$t(option.displayName)}}
    i.el-icon-error.type-name(v-if="activeType.length", @click="setMediaTypeFilterActive('allMedia'); activeType = ''")
</template>

<script>

export default {
  props: ['side'],
  data () {
    return {
      activeType: '',
      options: [
        { command: 'Image', displayName: 'Images', icon: 'image' },
        { command: 'Video', displayName: 'Videos', icon: 'video' },
        { command: 'Audio', displayName: 'Audio', icon: 'headphones-alt' },
        { command: 'PlayList', displayName: 'Playlists', icon: 'film', divided: true },
        { command: 'PlayListLayout', displayName: 'Layouts', icon: 'layer-group' },
        { command: 'PlayListExtended', displayName: 'PLaylists Extensions', icon: 'camera-retro' },
        { command: 'HTML5app', displayName: 'HTML5 applet', icon: 'code', divided: true },
        { command: 'HTMLzip', displayName: 'HTML zip', icon: 'compress' }
      ]
    }
  },
  methods: {
    setMediaTypeFilterActive (type) {
      this.activeType = type
      this.$emit('setMediaTypeFilterActive', type)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.filter-by-type-button {
  border: 0px solid red;
  padding: 0px 5px 4px 0px;
  margin: 0px 0px 0px 0px;
  .active {
    color: $--color-warning;
  }
  .type-name {
    color: $--color-text-secondary;
    margin-left: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/FilterByTypeButton.vue